export enum TypeFicheExpressionBesoinEnum {
  ECHAFAUDAGE = '0',
  LEVAGE = '1',
  NETTOYAGE = '2',
  CALORIFUGEAGE = '3',
}
